import React from 'react'
import DashboardTable from '../dashboardtable/dashboardtable';
import {useHistory } from 'react-router-dom';
// import data from './data.json'
import {useState} from 'react';
import search from '../../../../assets/images/search.png'
import add from '../../../../assets/images/add.png'
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { DataGrid } from '@mui/x-data-grid'
import Table from 'react-bootstrap/Table';
import jsPDF from "jspdf";
import "jspdf-autotable";

let genData=[]

// Export to pdf
function exportPDF()
{
    const unit = "pt";
    const size = "A4"; // Use A1, A2, A3 or A4
    const orientation = "portrait"; // portrait or landscape

    const marginLeft = 40;
    const doc = new jsPDF(orientation, unit, size);

    doc.setFontSize(15);

    const title = "My Awesome Report";
    const headers = [["Driver ID", "Load No", "Broker", "Pickup", "Destination", "Pickup Date", "Delivery Date", "Rate"]];

    const data = genData.map(itm=> [itm.driver_id,itm.load_no,itm.broker,itm.pickup,itm.destination,itm.pickup_date,itm.delivery_date,itm.rate,]);

    let content = {
        startY: 50,
        head: headers,
        body: data
    };

    doc.text(title, marginLeft, 40);
    doc.autoTable(content);
    doc.save("report.pdf")
}

function Load() {
    const history = useHistory();
    // temporary data
    const tempData=[
        {"id":1,"driver_id":1,"load_no":"1","broker":"hamza","pickup":"lorem 12 data","destination":"lorem 123 data","pickup_date":"22/2/6","delivery_date":"22/2/6","rate":3000},
        {"id":2,"driver_id":2,"load_no":"2","broker":"ali","pickup":"lorem 12 data","destination":"lorem 123 data","pickup_date":"22/3/5","delivery_date":"22/3/5","rate":3000},
        {"id":3,"driver_id":3,"load_no":"3","broker":"ahmad","pickup":"lorem 12 data","destination":"lorem 123 data","pickup_date":"22/4/4","delivery_date":"22/4/4","rate":3000},
        {"id":4,"driver_id":4,"load_no":"4","broker":"sohail","pickup":"lorem 12 data","destination":"lorem 123 data","pickup_date":"22/5/3","delivery_date":"22/5/3","rate":3000},
        {"id":5,"driver_id":5,"load_no":"5","broker":"sheroze","pickup":"lorem 12 data","destination":"lorem 123 data","pickup_date":"22/6/2","delivery_date":"22/6/2","rate":3000},
    ]
    // table data states
    let [data,setData]=useState(tempData);
    // modal setting states
    const [modalShow, setModalShow] = React.useState(false);
    let [selectedTableRows,setSelectedTableRows]=useState([]);
    // Set Selected State
    function getSelectedData(_data) {
        setSelectedTableRows(_data);
        genData=[];
    }
    // click generate
    function clickGenerate() {

        selectedTableRows.map((itm,i)=>{
            genData.push(data[itm-1]);
        })
        // diplay model true
        setModalShow(true)
    }
    // sort by name
    function sortByName(e,_value) {
        e.preventDefault();
    }




    return (
        <>
            <div className='driver-head'>
                <h3 className='dashboard-head-title'>Loads</h3>
                <div>
                    <div className='input-header-admin'>
                        <input
                            onChange={(event => sortByName(event.target.value))}
                            type="text"
                            placeholder='Driver Name' />
                    </div>
                    <div className='input-header-admin'>
                        <input
                            type="text"
                            placeholder='From-To' />
                    </div>
                    <div className='input-header-admin'>
                        <input
                            type="text"
                            placeholder='To' />
                    </div>
                    <div className='nav-buttons'>
                        <button
                            onClick={() => clickGenerate()}
                            style={{ background: '#FF7B00', marginRight: '15px' }}>
                            Generate
                        </button>
                    </div>
                    {/*<div className='input-header-admin'>*/}
                    {/*    <input*/}
                    {/*        type="text"*/}
                    {/*        placeholder='Search' />*/}
                    {/*    <img src={search} alt="" />*/}
                    {/*</div>*/}
                    <div className='nav-buttons'>
                        <button
                            onClick={() => history.push('/add-load')}
                            style={{ background: '#FF7B00', marginRight: '15px' }}>
                            <img src={add} alt="" />  Add Load
                        </button>
                    </div>
                </div>
            </div>
            <div className='dashboard-table-wrapper_'>
                {/*<DashboardTable size={10} columns={columns} rows={data.data} height={"510px"} fucn={getSelectedData} />*/}
                <div className='dashboard-table-wrapper'>
                    <div className='dashboard-table' style={{ height: "510px" }}>
                        <DataGrid
                            rows={data}
                            columns={columns}
                            pageSize={10}
                            disableSelectionOnClick
                            checkboxSelection
                            onSelectionModelChange={itm => getSelectedData(itm)}
                        />
                    </div>
                </div>
            </div>
            {/*  Generate Modal  */}
            <MyVerticallyCenteredModal
                show={modalShow}
                onHide={() => setModalShow(false)}
            />
        </>
    )
}

// Generate Modal Function
function MyVerticallyCenteredModal(props) {
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Selected Data
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {/*<h4>Centered Modal</h4>*/}
                <Table className="table" id="example">
                    <thead>
                    <tr>
                        <th>Driver ID</th>
                        <th>Load No.</th>
                        <th>Broker</th>
                        <th>Pickup</th>
                        <th>Destination</th>
                        <th>Pickup Date</th>
                        <th>Delivery Date</th>
                        <th>Rate</th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        genData.map((itm,i)=>(
                            <tr>
                                <td>{itm.driver_id}</td>
                                <td>{itm.load_no}</td>
                                <td>{itm.broker}</td>
                                <td>{itm.pickup}</td>
                                <td>{itm.destination}</td>
                                <td>{itm.pickup_date}</td>
                                <td>{itm.delivery_date}</td>
                                <td>{itm.rate}</td>
                            </tr>
                        ))
                    }
                    </tbody>
                </Table>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={exportPDF}>Generate PDF</Button>
                <Button onClick={props.onHide}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
}



const columns = [
    { field: 'driver_id', headerName: 'Driver ID', minWidth: 60 },
    { field: 'load_no', headerName: 'Load No.', minWidth: 60 },
    { field: 'broker', headerName: 'Broker', minWidth: 60 },
    { field: 'pickup', headerName: 'Pickup', minWidth: 60 },
    { field: 'destination', headerName: 'Destination', minWidth: 225 },
    { field: 'pickup_date', headerName: 'Pickup Date', minWidth: 225 },
    { field: 'delivery_date', headerName: 'Delivery Date', minWidth: 60 },
    { field: 'rate', headerName: 'Rate', minWidth: 30 }
];

export default Load